module.exports = __webpack_public_path__ + "static/media/lets_step_through_this_together.48d2b944.png";